export const alertStyle = {
    position: "absolute",
    background: "#fffee8",
    color: "RED",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "30vw",
    height: "30vh",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    borderRadius: '1em',
    border: "3px solid rgb(51, 51, 51)",
      padding: "1em",
  }

export const buttonStyle = {
    backgroundColor: "rgb(73 73 73)",
    color: "white",
    textDecoration: "none",
    width: "30%"
  }